import React, { useRef, useState, useEffect } from 'react'
import { DateRangePickerDropdown } from '../DashboardOverviewFilter'
import { FiSearch } from 'react-icons/fi'
import useSWR from 'swr'
import { fetcher } from '../../utils/api'


const visibilityOptions = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "true"
  },
  {
    label: "Inactive",
    value: "false"
  }
]

const sortOptions = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Newest First",
    value: "desc"
  },
  {
    label: "Oldest First",
    value: "asc"
  }
]

const productTypes = [
  {
    label: "All Types",
    value: "All Types"
  },
  {
    label: "Products",
    value: "product"
  },
  {
    label: "Service",
    value: "service"
  }
]

const ServiceOrderFilter = ({
  placeholder = "Search...",
  suggestions = [],
  onSearch,
  searchValue,
  setSearchValue,
  states,
  setStates,
  handleChange,
  hideDateRange = false,
  hideTypeFilter = false
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [showCategoryFilter, setShowCategoryFilter] = useState(false)
  const [showTypeFilter, setShowTypeFilter] = useState(false)
  const [showVisibilityFilter, setShowVisibilityFilter] = useState(false)
  const [showSortFilter, setShowSortFilter] = useState(false)
  const { data: categories, isLoading: isLoadingCategories } = useSWR(`service-orders/categories/`, fetcher)

  const inputRef = useRef(null)
  const categoryFilterRef = useRef(null)
  const visibilityFilterRef = useRef(null)
  const sortFilterRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryFilterRef.current && !categoryFilterRef.current.contains(event.target)) {
        setShowCategoryFilter(false)
      }
      if (visibilityFilterRef.current && !visibilityFilterRef.current.contains(event.target)) {
        setShowVisibilityFilter(false)
      }
      if (sortFilterRef.current && !sortFilterRef.current.contains(event.target)) {
        setShowSortFilter(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // Filter suggestions based on input
  const filteredSuggestions = Array.isArray(suggestions)
    ? suggestions.filter(s =>
      typeof s === 'string' && s.toLowerCase().includes(searchValue.toLowerCase())
    )
    : []

  const handleInputChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
  }

  const handleSuggestionClick = (suggestion) => {
    setSearchValue(suggestion)
    setShowSuggestions(false)
    inputRef.current?.blur()
    if (onSearch) onSearch(suggestion)
  }

  return (
    <div className='flex flex-col lg:flex-row lg:items-center lg:justify-between lg:gap-14 gap-5 w-full'>
      {/* SEARCH */}
      <div className='flex flex-row gap-2'>
        <div className='w-full relative'>
          <input
            type="text"
            placeholder={placeholder}
            className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-9 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
            value={searchValue}
            onChange={handleInputChange}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
            ref={inputRef}
          />
          <FiSearch size={20} className='absolute left-2 top-1/2 -translate-y-1/2 text-black/70 dark:text-white/70' />
          {showSuggestions && filteredSuggestions?.length > 0 && (
            <div className="absolute left-0 right-0 mt-1 bg-white dark:bg-secondaryDark rounded-md shadow-xl z-50 max-h-60 overflow-y-auto">
              {filteredSuggestions.map((suggestion, idx) => (
                <div
                  key={idx}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark  text-black dark:text-white text-sm"
                  onMouseDown={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>
        <button
          onClick={() => onSearch && onSearch(searchValue)}
          className='bg-yellowcolor hover:bg-yellowcolor/80 text-black px-6 flex items-center justify-center py-2 rounded-md'>
          Search
        </button>
      </div>

      <div className='flex flex-col sm:flex-row md:flex-row gap-2 sm:items-center md:items-center'>
        {/* type Filter */}
        {!hideTypeFilter && <div className='w-full md:w-fit relative' ref={categoryFilterRef}>
          <button
            onClick={() => {
              setShowTypeFilter(!showTypeFilter)
              setShowCategoryFilter(false)
              setShowVisibilityFilter(false)
              setShowSortFilter(false)
            }}
            className='w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white px-4 flex items-center justify-center py-2 rounded-md'>
            <span className="text-sm capitalize">{states?.productType ? states?.productType : "All Types"}</span>
          </button>
          {showTypeFilter && (
            <div className='absolute top-10 left-0 w-48 bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md shadow-xl z-50'>
              <p className="text-sm font-bold text-black px-4 py-2 dark:text-white">Filter By Type:</p>
              {productTypes?.map((item, index) => (
                <button key={index}
                  name="productType"
                  id="productType"
                  className='px-4 w-full text-left py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark text-black dark:text-white text-sm'
                  onClick={() => {
                    // setStates({...states, type: item?.value})
                    handleChange({ target: { name: 'productType', value: item.value } })
                    setShowTypeFilter(false)
                  }}
                >{item.label}</button>
              ))}
            </div>
          )}
        </div>}

        {/* Category Filter */}
        <div className='w-full md:w-fit relative' ref={categoryFilterRef}>
          <button
            onClick={() => {
              setShowCategoryFilter(!showCategoryFilter)
              setShowVisibilityFilter(false)
              setShowSortFilter(false)
            }}
            className='w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white px-4 flex items-center justify-center py-2 rounded-md'>
            <span className="text-sm">{states?.category ? states?.category : "Category"}</span>
          </button>
          {showCategoryFilter && (
            <div className='absolute top-10 left-0 w-48 bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md shadow-xl z-50'>
              <p className="text-sm font-bold text-black px-4 py-2 dark:text-white">Filter By Category:</p>
              {categories?.map((item, index) => (
                <button key={index}
                  className='px-4 w-full text-left py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark text-black dark:text-white text-sm'
                  onClick={() => {
                    handleChange({ target: { name: 'category', value: item.name } })
                    setShowCategoryFilter(false)
                  }}
                >{item.name}</button>
              ))}
            </div>
          )}
        </div>

        {/* Visibility Filter */}
        <div className='w-full md:w-fit relative' ref={visibilityFilterRef}>
          <button
            onClick={() => {
              setShowVisibilityFilter(!showVisibilityFilter)
              setShowCategoryFilter(false)
              setShowSortFilter(false)
            }}
            className='w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white px-4 flex items-center justify-center py-2 rounded-md'>
            <span className="text-sm">{states?.visibility ? "Active" : "Inactive"}</span>
          </button>
          {showVisibilityFilter && (
            <div className='absolute top-10 left-0 w-48 bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md shadow-xl z-50'>
              <p className="text-sm font-bold text-black px-4 py-2 dark:text-white">Filter By Visibility:</p>
              {visibilityOptions.map((item, index) => (
                <button key={index}
                  className='px-4 w-full text-left py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark text-black dark:text-white text-sm'
                  onClick={() => {
                    // if (item.value)
                    handleChange({ target: { name: 'visibility', value: item.value } })
                    setShowVisibilityFilter(false)
                  }}
                >{item.label}</button>
              ))}
            </div>
          )}
        </div>

        {/* Sort Filter */}
        <div className='w-full md:w-fit relative' ref={sortFilterRef}>
          <button
            onClick={() => {
              setShowSortFilter(!showSortFilter)
              setShowCategoryFilter(false)
              setShowVisibilityFilter(false)
            }}
            className='w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white px-4 flex items-center justify-center py-2 rounded-md'>
            <span className="text-sm">{states?.sort === "desc" ? "Newest First" : states?.sort === "asc" ? "Oldest First" : "Sort"}</span>
          </button>
          {showSortFilter && (
            <div className='absolute top-10 left-0 w-48 bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md shadow-xl z-50'>
              <p className="text-sm font-bold text-black px-4 py-2 dark:text-white">Sort By:</p>
              {sortOptions.map((item, index) => (
                <button key={index}
                  className='px-4 w-full text-left py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-secondaryDark text-black dark:text-white text-sm'
                  onClick={() => {
                    handleChange({ target: { name: 'sort', value: item.value } })
                    setShowSortFilter(false)
                  }}
                >{item.label}</button>
              ))}
            </div>
          )}
        </div>

        {!hideDateRange && (
          <div className='w-full md:w-fit flex flex-row items-center gap-2'>
            <div className='w-full'>
              <select
                name="page_count"
                onChange={handleChange}
                value={states.page_count}
                className="py-2.5 capitalize px-4 pe-9 block w-full border-gray-200 rounded-lg text-sm focus:border-yellowcolor focus:ring-yellowcolor disabled:opacity-50 disabled:pointer-events-none dark:bg-dark border dark:border-border-dark dark:text-white ">
                <option>Select Page</option>
                {[
                  '10 per page',
                  '25 per page',
                  '50 per page',
                  '75 per page',
                  '100 per page'
                ].map((item, index) => (
                  <option className='capitalize' key={index} value={item}>{item}</option>
                ))}
              </select>
            </div>

           
          </div>
        )}


      </div>
    </div>
  )
}

export default ServiceOrderFilter